<style lang="less" scoped>
    .contain {
        padding: 10px 30px 20px;
        position: relative;
        div {
            margin: 10px 0;
            font-size: 14px;
        }
    }
    .close-btn {
        // position: absolute;

        margin: 0px !important;
        padding: 0 !important;
    }
</style>
<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :close-on-click="false"
      :nudge-width="100"
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          small
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            dark
            color="primary"
          >
            mdi-help-circle
          </v-icon>
        </v-btn>
      </template>

      <v-card>
        <div>
          <div class="close-btn">
            <v-btn
              size="24"
              icon
              @click="menu = false"
            >
              <v-icon size="24">
                mdi-close
              </v-icon>
            </v-btn>
          </div>
          <div class="contain">
            <slot />
          </div>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        menu:false
      }
    },
    mounted() {
      setTimeout(() => {
        this.menu = true
      }, 600)
    }
  }
</script>